import MODULE_NAME from './app.js';
import env from '../../env.json';

/**
 * @ngdoc object
 * @name festzelt-os
 * @description
 *
 */
angular.module(MODULE_NAME)
    .run([
        'Acl',
        '$q',
        '$rootScope',
        '$http',
        '$auth',
        '$state',
        '$transitions',
        '$window',
        'Users',
        '$uibModal',
        '$anchorScroll',
        run
    ]);

function run(Acl, $q, $rootScope, $http, $auth, $state, $transitions, $window, Users, $uibModal, $anchorScroll) {

    const timers = {};

    $rootScope.$state = $state;
    $rootScope.collapsedBody = false;
    $rootScope.hasTabs = false;
    $rootScope.curDate = new Date();
    $rootScope.currentYear = env.currentYear || $rootScope.curDate.getFullYear();
    $rootScope.lastYear = $rootScope.currentYear-1;
    $rootScope.displayLastYearBookings = localStorage.getItem('display-last-year-bookings');
    $rootScope.validPdfMessureRegex = /^([0-9,]+)(\.[0-9]{1,2})?(mm)$/;
    $rootScope.globalDateFormats = {
        dateTime: 'd.M.yyyy HH:mm',
        dateTimeExact: 'd.M.yyyy HH:mm:ss',
        date: 'd.M.yyyy',
        time: 'HH:mm'
    };
    $rootScope.globalMomentDateFormats = {
        dateTime: 'D.M.YYYY HH:mm',
        dateTimeExact: 'D.M.YYYY HH:mm:ss',
        date: 'D.M.YYYY',
        time: 'HH:mm'
    };
    // angular.element(window).width() < 960;

    $http.defaults.headers.common['Authorization'] = function () {
        if ($auth.getToken()) {
            return 'Bearer ' + $auth.getToken();
        }
    };

    $http.defaults.headers.delete = {
        'Content-Type': 'application/json'
    };

    $transitions.onBefore({to: 'app.**'}, (trans) => {
        timers[trans.to().name] = Date.now();
        if (!$auth.isAuthenticated()) {
            return trans.router.stateService.target('auth.login');
        }

        $rootScope.editing = false;

        return $q.when($rootScope.user || Users.dispatch('getLoggedIn')
            .then(() => {
                $rootScope.user = Users.state.loggedin.profile;
                $rootScope.company = Users.state.company;
                $rootScope.currentYear = Users.state.company.settings.core.current_year;
                $rootScope.lastYear = Users.state.company.settings.core.last_year;
                        Acl.setUser($rootScope.user);
                Acl.setCompany($rootScope.company);
                return $rootScope.user;
            }))
            .then(() => {
                if (trans.to().data.module && !Acl.hasModule(trans.to().data.module)) {
                    return trans.router.stateService.go('app.dashboard');
                }
                if (trans.to().data.rights && !Acl.hasRight(trans.to().data.rights)) {
                    Acl.accessDenied(trans.to().data.rights);
                    return trans.router.stateService.back();
                }
            })
    });

    $uibModal.backdrop = 'static';
    $anchorScroll.yOffset = 80;
}



// WEBPACK FOOTER //
// ./src/app/app-module-run.js